<template>
  <section class="flex align-middle justify-center sm:py-40">
    <div class="flex flex-col">
      <Card class="w-448 max-w-screen p-24">
        <form id="add-employer-form" @submit.prevent="submit()">
          <h1 class="text-h1 mb-24">Add your employer</h1>
          <fieldset>
            <SearchComboBox
              id="companySearchBox"
              ref="companySearchBox"
              allowEmptyResults
              :results="clientSearchResults"
              type="text"
              labelName="Your employer's name"
              class="mb-24"
              helperText="Optional"
              @selected="queryFragment"
            />
          </fieldset>
          <Button class="w-full" variant="primary" value="Continue" size="medium" type="submit" />
        </form>
      </Card>
    </div>
  </section>
</template>

<script lang="ts">
import SearchComboBox from '@/components/search_combo_box/SearchComboBox.vue';
import Button from '@/components/button/Button.vue';
import Card from '@/components/card/Card.vue';
import { sendSegmentEvent } from '@/lib/segment';
import { CLIENT_SEARCH_QUERY, CORPORATE_CLIENT_QUERY } from '../../../../graphql/bh_benefits/queries';
import { sendBrazeEvent } from '../../../../lib/braze';
import { BASIC_REGISTRATION_ADD_YOUR_EMPLOYER_LOADED } from '../../../../lib/constants/braze_custom_events';

export default {
  name: 'AddYourEmployer',
  components: {
    SearchComboBox,
    Button,
    Card,
  },
  data(): any {
    return {
      employerNameInput: '',
      selectedCompanySlug: '',
      selectedCompanyName: '',
      selectedBhClientId: '',
      clientSearchResults: [],
    };
  },
  mounted() {
    sendBrazeEvent(BASIC_REGISTRATION_ADD_YOUR_EMPLOYER_LOADED);
  },
  methods: {
    invalidEmployerEntered() {
      sendSegmentEvent('Invalid Employer Entered', {
        employerEntered: this.employerNameInput,
      });
    },
    validateEmployerEntered(employer: string): boolean {
      return employer?.trim().length > 0;
    },
    async queryGetClientSlug(bhClientId: string) {
      await this.$apollo
        .query({
          query: CORPORATE_CLIENT_QUERY,
          variables: {
            bhClientId: Number(bhClientId),
          },
        })
        .then(({ data }) => {
          const { slug, name } = data.corporateClient;
          this.selectedCompanySlug = slug;
          this.selectedCompanyName = name;
          this.selectedBhClientId = bhClientId;
        })
        .catch((error) => {
          this.selectedCompanySlug = '';
          this.selectedCompanyName = '';
          this.selectedBhClientId = '';
          // eslint-disable-next-line no-console
          console.warn('GraphQL query error:', error);
        });
    },
    async queryFragment({ value, display }) {
      this.employerNameInput = display;
      if (value) {
        // user selected client from dropdown
        await this.queryGetClientSlug(value);
      } else {
        // user typing in fragment
        await this.$apollo
          .query({
            query: CLIENT_SEARCH_QUERY,
            variables: {
              fragment: display,
            },
          })
          .then(({ data }) => {
            const corporateClientsForComboBox = data.clientSearch.map(({ clientId, clientName }) => {
              return { display: clientName, value: `${clientId}` };
            });
            this.selectedCompanySlug = '';
            this.selectedCompanyName = '';
            this.selectedBhClientId = '';
            this.clientSearchResults = corporateClientsForComboBox;
          })
          .catch((error) => {
            // eslint-disable-next-line no-console
            console.error('GraphQL query error:', error);
          });
      }
    },
    submit() {
      if (!this.selectedCompanySlug) {
        // Track invalid employer if user typed something
        if (this.validateEmployerEntered(this.employerNameInput)) {
          this.invalidEmployerEntered();
        }
        // No valid employer selected - allow skip to care type
        this.$router.push({ name: 'registration-care-type' });
      } else {
        // Valid employer selected - proceed to upgrade request
        this.$router.push({ name: 'registration-request-upgrade', query: { slug: this.selectedCompanySlug } });
      }
    },
  },
};
</script>
